import React from "react"
import Markdown from "./markdown"

class H1 extends React.Component {
  render() {
    const markdown = <Markdown input={this.props.title} />
    return <h1 className="is-size-5 has-text-weight-semibold">{markdown}</h1>
  }
}

export default H1
